import React, { useState } from "react";
import { Link, LinkProps } from "react-router-dom";
import { colors } from "../../../components/colors";
import { SmallWidgetBase } from "./SmallWidgetBase";

type SmallLinkCardInternalProps = {
  icon?: React.ReactNode;
  header: string;
  subtitle?: string;
  to: string;
} & LinkProps;

export const SmallWidgetInternal = ({
  icon,
  header,
  subtitle,
  to,
  ...rest
}: SmallLinkCardInternalProps) => {
  const [_borderColor, setBorderColor] = useState<string>(colors.transparent);

  return (
    <Link
      to={to}
      className="d-flex flex-row align-items-center justify-content-between p-4 b-4px w-100 h-100"
      style={{
        gap: "16px",
        backgroundColor: colors.ctaLight,
        textDecoration: "none",
        border: "1px solid",
        borderColor: _borderColor,
      }}
      onMouseEnter={() => setBorderColor(colors.ctaMain)}
      onMouseLeave={() => setBorderColor(colors.transparent)}
      {...rest}
    >
      <SmallWidgetBase header={header} subtitle={subtitle} icon={icon} />
    </Link>
  );
};
